import { useSyncRolexCmpTracking } from './use-sync-rolex-cmp-tracking'
import { useRolexTrackingScript } from '@lib/use-rolex-tracking-script-store'

type Event =
  | 'getDirections'
  | 'contactCall'
  | 'findStore'
  | 'whatsappContact'
  | 'addToBag'
  | 'contactForm'
  | 'pageView'

export function useRolexEventTracking() {
  const { scriptIsLoaded } = useRolexTrackingScript()
  const rolexConsent = useSyncRolexCmpTracking()

  function track(event: Event) {
    if (rolexConsent && scriptIsLoaded) {
      // @ts-ignore
      _satellite.track(event)
    }
  }

  return {
    track,
  }
}
